module.exports = __webpack_public_path__ + "static/scholle3_mini-d1be04fa226fa775c9379e22d3f01fc6.png";